export default "__VITE_ASSET__NjcUxjqg__"